import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Clock } from "lucide-react";

/**
 * Shown when the user has been idle while a timer is running.
 *
 * Props:
 * open – controlled open state
 * idleMinutes – how many minutes idle
 * onDeductStop – "Deduct idle & stop timer"
 * onKeepRunning – "Keep timer running" (dismiss, reset idle clock)
 * onStopKeepAll – "Stop timer, keep full time"
 */
const IdleTimerModal = ({ open, idleMinutes, onDeductStop, onKeepRunning, onStopKeepAll }) => {
  const hrs = Math.floor(idleMinutes / 60);
  const mins = idleMinutes % 60;
  const label = hrs > 0 ? `${hrs}h ${mins}m` : `${mins}m`;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onKeepRunning()}>
      <DialogContent
        className="max-w-md"
        // Avoid restoring focus onto TimerBar Stop (can re-open Stop dialog).
        onCloseAutoFocus={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <div className="flex items-center gap-3 mb-1">
            <div className="w-10 h-10 rounded-lg bg-amber-100 dark:bg-amber-950/30 flex items-center justify-center">
              <Clock className="w-5 h-5 text-amber-600" />
            </div>
            <DialogTitle>You've been idle</DialogTitle>
          </div>
          <DialogDescription>
            No activity detected for <span className="font-semibold text-brand-ink">{label}</span>.
            Your timer is still running. What would you like to do?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          <Button
            type="button"
            variant="default"
            className="w-full bg-brand-surface hover:bg-brand-subtle"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onDeductStop();
            }}
          >
            Deduct {label} idle &amp; stop timer
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full border-brand-border"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onKeepRunning();
            }}
          >
            Keep timer running
          </Button>
          <Button
            type="button"
            variant="ghost"
            className="w-full text-brand-steel"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onStopKeepAll();
            }}
          >
            Stop timer, keep full time
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default IdleTimerModal;
